
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"43","height":"25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M39.403 22.267l-1.907-1.934-1.982 1.934H23.26v-9h-3.889L24.214 3.2h4.696l1.688 3.467V3.2h5.87l1.027 2.6 1.028-2.6h4.476V1.667C42.999.733 42.192 0 41.164 0H1.834C.807 0 0 .733 0 1.667v21.666C0 24.267.807 25 1.834 25h39.33C42.192 25 43 24.267 43 23.333v-1.066h-3.596z","fill":"#0071CE"}}),_c('path',{attrs:{"d":"M39.918 21.2H43l-4.036-3.933L43 13.4h-3.008l-2.569 2.533-2.495-2.533h-3.081l4.109 3.933-4.11 3.867h3.01l2.567-2.533 2.495 2.533z","fill":"#0071CE"}}),_c('path',{attrs:{"d":"M26.93 19.4v-1.2h4.843v-1.8H26.93v-1.2h4.916v-1.8h-7.264v7.8h7.264v-1.8H26.93zM40.725 12.267h2.202V4.4l-3.523.067-1.907 4.866-1.981-4.866h-3.67v7.8h2.349V6.8l2.201 5.467h2.055L40.725 6.8v5.467z","fill":"#0071CE"}}),_c('path',{attrs:{"d":"M28.104 4.467h-3.008l-3.816 7.8h2.569l.733-1.534h3.963l.733 1.534h2.642l-3.816-7.8zM25.39 8.933L26.563 6.4l1.174 2.533H25.39zM40.872 17.067L43 19.2v-4.267l-2.128 2.134z","fill":"#0071CE"}})])
          )
        }
      }
    